<template>
  <div class="base-layout">
    <AppHeader :key="'app-header'" />
    <div>
      <slot name="default"></slot>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import LangSwitcher from '~/components/shared/LangSwitcher.vue'

export default defineComponent({
  components: { LangSwitcher },
})
</script>
